import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, DataRoomEmail } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDataRoomLenderEmailQuery(
	dataRoomGuid: Guid | undefined,
	dataRoomUserGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<DataRoomEmail[], unknown, DataRoomEmail[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.Email(dataRoomGuid, dataRoomUserGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomEmail[]>(
				api.get(CerebroApiEndpoints.DataRoomUsers.Email(dataRoomGuid, dataRoomUserGuid))
			),
		options
	);
}
